import bookingRoutes from './bookings.js'
import yellowPagesRoutes from './yellow-pages.js'
import contactRoutes from './contacts.js'
import documentRoutes from './documents.js'
import entityRoutes from './entities.js'
import inquiryRoutes from './inquiries.js'
import settingRoutes from './settings.js'
import shelterRoutes from './shelter.js'
const routes = [
  {
    path: '/register',
    component: () => import('@/views/Register.vue'),
    name: 'register',
    meta: {
      auth: false
    }
  },
  {
    path: '/auth',
    component: () => import('@/layouts/AuthLayout.vue'),
    meta: {
      auth: false
    },
    children: [
      {
        path: 'login',
        name: 'auth-login',
        component: () => import('@/views/Login.vue'),
        meta: {
          auth: false
        }
      },
      {
        path: 'logout',
        name: 'auth-logout',
        component: () => import('@/views/Logout.vue'),
        meta: {
          auth: false
        }
      },
      {
        path: 'reset',
        name: 'auth-reset',
        component: () => import('@/views/ResetPassword.vue'),
        meta: {
          auth: false
        }
      },
      {
        path: 'aaul/:token/:path?',
        name: 'aaul',
        component: () => import('@/views/Aaul.vue'),
        meta: {
          auth: false
        }
      },
      {
        path: 'bridge/:token/:path?',
        name: 'bridge',
        component: () => import('@/views/Bridge.vue'),
        meta: {
          auth: false
        }
      }
    ]
  },
  {
    path: '/',
    component: () => import('@/layouts/AppLayout.vue'),
    meta: {
      auth: true
    },
    children: [
      {
        path: '',
        name: 'dashboard',
        component: () => import('@/modules/dashboard/index.vue')
      },
      {
        path: '/feratel',
        name: 'feratel',
        component: () => import('@/views/Feratel.vue')
      },
      {
        path: 'forbidden',
        name: 'forbidden',
        component: () => import('@/views/Forbidden.vue'),
        meta: {
          auth: false
        }
      },
      {
        path: 'not-found',
        name: 'not-found',
        component: () => import('@/views/NotFound.vue'),
        meta: {
          auth: false
        }
      },
      bookingRoutes,
      yellowPagesRoutes,
      contactRoutes,
      documentRoutes,
      inquiryRoutes,
      settingRoutes,
      entityRoutes,
      shelterRoutes,
      { path: '/:pathMatch(.*)*', name: 'not-found2', component: () => import('@/views/NotFound.vue') },
    ]
  }
]

export default routes
